import { Box, Grid, GridItem, VStack } from '@chakra-ui/react';
import { Tag, TruncatableText } from 'Atoms';
import { Dispatch, SetStateAction } from 'react';
import { Typography } from 'Tokens';
import { MultiFrameCategoryAndStandards } from './DataPointsBank';
import { uniq } from 'lodash';
import { useParams } from 'react-router-dom';
import { MaterialityStatusBox } from '../DoubleMaterialityAssessment/MaterialityUtils';
import { Materiality } from '../DoubleMaterialityAssessment/DoubleMaterialityAssessment.d';

export const GeneralView = ({
  categoryAndStandards,
  selectedFrameworkRef,
  setSelectedView,
  setSelectedStandard,
  setViewHistory,
}: {
  categoryAndStandards: MultiFrameCategoryAndStandards;
  selectedFrameworkRef: string;
  setSelectedView: Dispatch<SetStateAction<string>>;
  setSelectedStandard: Dispatch<
    SetStateAction<MultiFrameCategoryAndStandards[number]['mfStandards'][number] | undefined>
  >;
  setViewHistory: Dispatch<SetStateAction<string[]>>;
}) => {
  const { framework = '' } = useParams();
  return (
    <VStack alignSelf={'start'} alignItems={'start'} width={'100%'} gap={'40px'}>
      {categoryAndStandards
        .filter((ct) => {
          if (selectedFrameworkRef !== 'all') {
            return ct.mfStandards.some((std) =>
              std.standards.some((st) => st.frameworkRef === selectedFrameworkRef)
            );
          }
          return true;
        })
        .map((category) => {
          return (
            <VStack width={'100%'} alignItems={'start'} gap={'10px'} key={category?.mfCategoryRef}>
              <Box>
                <Typography
                  fontSize={'12px'}
                  color={'text.hint'}
                  fontFamily={'text.Overline'}
                  fontWeight={'600'}
                >
                  {category?.mfCategoryName?.toUpperCase()}
                </Typography>
              </Box>
              <Grid templateColumns="repeat(3, 1fr)" gap={'10px'} width={'100%'}>
                {category.mfStandards.map((mfStandard) => {
                  const frameworks = uniq(
                    mfStandard.standards.map((standard) => {
                      if (selectedFrameworkRef === 'all') {
                        return standard.frameworkName;
                      }
                      if (selectedFrameworkRef === standard.frameworkRef) {
                        return standard.frameworkName;
                      }
                    })
                  ).filter((framework) => framework);
                  const frameworkStandard = mfStandard.standards.find(
                    (standard) => standard.frameworkRef === framework
                  );
                  return mfStandard.standards.find(
                    (standard) => standard.frameworkRef === selectedFrameworkRef
                  ) || selectedFrameworkRef == 'all' ? (
                    <GridItem key={mfStandard.mfStandardRef}>
                      <VStack
                        height={'128px'}
                        alignItems={'start'}
                        padding={'16px'}
                        gap={'2px'}
                        borderRadius={'10px'}
                        shadow="interactive"
                        bg="bg.elevated.interactive"
                        _hover={{
                          shadow: 'interactive.hover',
                          background: 'bg.elevated.interactive.hover',
                        }}
                        cursor="pointer"
                        onClick={() => {
                          setSelectedView('standardView');
                          setSelectedStandard(mfStandard);
                          setViewHistory((prevViewHistory) => [
                            ...prevViewHistory,
                            mfStandard.mfStandardName,
                          ]);
                        }}
                        justifyContent={'space-between'}
                      >
                        <VStack alignItems={'flex-start'} gap={'2px'} width={'100%'}>
                          <TruncatableText
                            fontSize={'14px'}
                            fontWeight={'600'}
                            as={'h4'}
                            text={mfStandard.mfStandardName}
                            width={'100%'}
                          />
                          <Typography fontSize={'12px'} color={'text.hint'}>
                            {frameworks.join(' · ')}
                          </Typography>
                        </VStack>
                        <VStack>
                          <MaterialityStatusBox
                            materiality={frameworkStandard?.materiality as Materiality}
                          />
                        </VStack>
                      </VStack>
                    </GridItem>
                  ) : (
                    <></>
                  );
                })}
              </Grid>
            </VStack>
          );
        })}
    </VStack>
  );
};
